module.exports = __webpack_public_path__ + "media/images/earth-blue-marble-7deee995d548fe65faff40285399575c.jpg";